/**
 * @generated SignedSource<<9a7224fd585c1c7cb19a84ce7bab82db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailTemplatesViewEmailTemplatesQuery$variables = Record<PropertyKey, never>;
export type EmailTemplatesViewEmailTemplatesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EmailTemplateList_query">;
};
export type EmailTemplatesViewEmailTemplatesQuery = {
  response: EmailTemplatesViewEmailTemplatesQuery$data;
  variables: EmailTemplatesViewEmailTemplatesQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplatesViewEmailTemplatesQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EmailTemplateList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmailTemplatesViewEmailTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailTemplate",
        "kind": "LinkedField",
        "name": "emailTemplates",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailTemplateIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usageCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reusable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentWithMarketingEmailAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c4dac84bf382bd426f317af2a62fe552",
    "id": null,
    "metadata": {},
    "name": "EmailTemplatesViewEmailTemplatesQuery",
    "operationKind": "query",
    "text": "query EmailTemplatesViewEmailTemplatesQuery {\n  ...EmailTemplateList_query\n}\n\nfragment EmailTemplateList_query on Query {\n  emailTemplates {\n    id\n    emailTemplateIdentifier\n    name\n    createdAt\n    updatedAt\n    usageCount\n    reusable\n    sentWithMarketingEmailAt\n  }\n}\n"
  }
};

(node as any).hash = "8b7d431fbc7a3bafabad668167aca3d8";

export default node;
